export interface Order {
  orderId: string;
  orderDate: string;
  retailerId: number;
  retailerSku: string;
  retailPrice: number;
}

export enum OrderSource {
  checkout = 'checkout',
  sync = 'sync',
  external = 'external',
}

export enum OrderEligibility {
  eligible = 'eligible',
  notEligible = 'notEligible',
}

export interface SubmitForRewardRequest {
  orders: Array<Order>;
}

export interface CreateScanContextRequest {
  browserInfo: {
    userAgent: string;
  };
  retailerId: number;
}
